export enum EProjectCreatorSecondStepForm {
  clientComment = 'clientComment',
}
